module.exports = __webpack_public_path__ + "static/media/NoteSent.dca68281.png";